(function($){

    var $controller  = {

        selector: 'img',
        collection: null,

        init: function() {
            this.listen();
        },
        
        listen: function() {
            
            setTimeout(function() {

                $($controller.selector).each(function() {
                    var $this = $(this);
                    var $image = new Image();
                    $image.src = $this.attr('src');
                    $($image).on('load', function() {
                        var $ratio = this.naturalWidth / this.naturalHeight;
                        // add classes
                        if($ratio > 1) {
                            // landscape
                            $this.addClass('landscape');
                        } else if($ratio < 1) {
                            // portrait
                            $this.addClass('portrait');
                        } else {
                            $this.addClass('square');
                        }
                    });
                });

            });

        }

    };

    $controller.init();

})(jQuery);


// WEBPACK FOOTER //
// ./tbo/js/listen/image/orientation.js